import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as DepositeActions from './deposite.action';
import { DepositeService } from './deposite.service';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { saveAs } from 'file-saver';

import { DepositeInventoryStatusesListModel } from '../../models/deposite/depositeInventoryStatuses';
import { DepositeSearchModel } from '../../models/deposite/depositeSearch';
import * as DepositeModels from '../../models/deposite/deposite';

import { SaveState } from '../../models/commonModels';
import { DepositeInventoryNote, DepositeInventoryNoteListModel } from '../../models/deposite/depositeInventoryNote';
import { DepositeInventoryNoteSearchModel } from '../../models/deposite/depositeInventoryNoteSearch';
import * as Models from '../../models/commonModels';
import { StorageService } from '../../shared/services/storage.service';

export interface DepositeStateModel {
  Deposite: Models.Response<DepositeModels.DepositeModel>;
  DepositeList: DepositeModels.DepositeListModel;
  DepositePreviewList: DepositeModels.DepositePreviewListModel;
  DepositeSearch: DepositeSearchModel;
  DepositeInventoryStatusesList: DepositeInventoryStatusesListModel;
  DepositeInventoryNoteList: DepositeInventoryNoteListModel;
  ProcessingDepositeReport: number;
  ProcessingDepositeInventoryReport: number;
  ProcessingDepositeAgregatedReport: number;
  ProcessingDepositeAgregatedExtendedReport: number;
  ProcessingDepositeUtilizationReport: number;
  ProcessingPdf: number;
  ImportAgregatedExtendedStatus: any;
  MarkedRegistrationNumbers: string[];
}

class DictionaryKeys {
  public static readonly DepositeInventoryStatusesList = "DepositeInventoryStatusesList";
}



@State<DepositeStateModel>({
  name: 'depositeState',
  defaults: {
    Deposite: null,
    DepositeList: null,
    DepositePreviewList: null,
    DepositeSearch: null,
    DepositeInventoryStatusesList: null,
    DepositeInventoryNoteList: null,
    ProcessingDepositeReport: null,
    ProcessingDepositeAgregatedReport: null,
    ProcessingDepositeAgregatedExtendedReport: null,
    ProcessingDepositeUtilizationReport: null,
    ProcessingPdf: null,
    ImportAgregatedExtendedStatus: false,
    MarkedRegistrationNumbers: null,
    ProcessingDepositeInventoryReport : null
  }
})

@Injectable()

  export class DepositeState {

    constructor(
      private depositeService: DepositeService,
      private bannerService: BannerService,
      private helperService: HelperService,
      private storageService: StorageService
  ) { }


  @Selector()
  static Deposite(state: DepositeStateModel) {
    return state.Deposite;
  }

  @Selector()
  static ImportAgregatedExtendedStatus(state: DepositeStateModel) {
    return state.ImportAgregatedExtendedStatus;
  }

  @Selector()
  static DepositeList(state: DepositeStateModel) {
    return state.DepositeList;
  }

  @Selector()
  static DepositePreviewList(state: DepositeStateModel) {
    return state.DepositePreviewList;
  }

  @Selector()
  static DepositeSearch(state: DepositeStateModel) {
    return state.DepositeSearch;
  }

  @Selector()
  static DepositeInventoryStatusesList(state: DepositeStateModel) {
    return state.DepositeInventoryStatusesList;
  }

  @Selector()
  static DepositeInventoryNoteList(state: DepositeStateModel) {
    return state.DepositeInventoryNoteList;
  }

  @Selector()
  static ProcessingDepositeAgregatedReport(state: DepositeStateModel) {
    return state.ProcessingDepositeAgregatedReport;
  }

  @Selector()
  static ProcessingDepositeAgregatedExtendedReport(state: DepositeStateModel) {
    return state.ProcessingDepositeAgregatedExtendedReport;
  }

  @Selector()
  static ProcessingDepositeReport(state: DepositeStateModel) {
    return state.ProcessingDepositeReport;
  }

  @Selector()
  static ProcessingDepositeUtilizationReport(state: DepositeStateModel) {
    return state.ProcessingDepositeUtilizationReport;
  }

  @Selector()
  static ProcessingPdf(state: DepositeStateModel) {
    return state.ProcessingPdf;
  }

  @Selector()
  static MarkedRegistrationNumbers(state: DepositeStateModel) {
    return state.MarkedRegistrationNumbers;
  }

  @Selector()
  static ProcessingDepositeInventoryReport(state: DepositeStateModel) {
    return state.ProcessingDepositeInventoryReport;
  }


  @Action(DepositeActions.GetDepositeAgregatedReport)
  GetDepositeAgregatedReport(
      context: StateContext<DepositeStateModel>,
      action: DepositeActions.GetDepositeAgregatedReport
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie raportu, proszę czekać.');

    this.depositeService.getReportAgregated(action.Search).subscribe(ret => {
      const file = new File([ret], `Depozyty-pojedynczo-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
      },
        (error) => {

          this.helperService.SaveException('DepositeActions.GetDepositeAgregatedReport', error);

          this.bannerService.error('Błąd pobierania zagregowanego raportu depozytów.');
        },
      () => {
        context.setState(
          patch({
            ProcessingDepositeAgregatedReport: Math.random()
          })
        );

        }
      );
  }

  @Action(DepositeActions.GetDepositeAgregatedExtendedReport)
  GetDepositeAgregatedExtendedReport(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.GetDepositeAgregatedReport
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie raportu, proszę czekać.');

    this.depositeService.getReportAgregatedExtended(action.Search).subscribe(ret => {
      const file = new File([ret], `Depozyty-pojedynczo-rozszerzony-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('DepositeActions.GetDepositeAgregatedReport', error);

        this.bannerService.error('Błąd pobierania zagregowanego raportu depozytów.');
      },
      () => {
        context.setState(
          patch({
            ProcessingDepositeAgregatedExtendedReport: Math.random()
          })
        );

      }
    );
  }

  @Action(DepositeActions.GetDepositeReport)
  GetDepositeReport(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.GetDepositeReport
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie raportu, proszę czekać.');


    this.depositeService.getReport(action.Search).subscribe(ret => {
      const file = new File([ret], `Depozyty-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('DepositeActions.GetDepositeReport', error);

        this.bannerService.error('Błąd pobierania raportu depozytów.');
      },
      () => {

        context.setState(
          patch({
            ProcessingDepositeReport: Math.random()
          })
        );
      }
    );
  }

  @Action(DepositeActions.GetDepositeInventoryReport)
  GetDepositeReportInventory(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.GetDepositeInventoryReport
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie raportu inwentaryzacyjnego, proszę czekać.');


    this.depositeService.getInventoryReport(action.Search).subscribe(ret => {
      const file = new File([ret], `Depozyty-Inwentaryzacja-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('DepositeActions.GetDepositeReportInventory', error);

        this.bannerService.error('Błąd pobierania raportu depozytów.');
      },
      () => {

        context.setState(
          patch({
            ProcessingDepositeInventoryReport: Math.random()
          })
        );
      }
    );
  }

  @Action(DepositeActions.GetDepositeUtilizationReport)
  GetDepositeUtilizationReport(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.GetDepositeReport
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie raportu, proszę czekać.');


    this.depositeService.getReportUtilization(action.Search).subscribe(ret => {
      const file = new File([ret], `Depozyty-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('DepositeActions.GetDepositeUtilizationReport', error);

        this.bannerService.error('Błąd pobierania raportu depozytów.');
      },
      () => {

        context.setState(
          patch({
            ProcessingDepositeUtilizationReport: Math.random()
          })
        );
      }
    );
  }

  @Action(DepositeActions.GetDepositeInventoryNote)
  GetDepositeInventoryNote(
      context: StateContext<DepositeStateModel>,
      action: DepositeActions.GetDepositeInventoryNote
  ) {

    let errorMessage = 'Błąd pobierania notatek inwentaryzacyjnych.';

    context.setState(
        patch({
          DepositeInventoryNoteList: null
        })
      );

    this.depositeService.getDepositeInventoryNote(action.Search).subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              DepositeInventoryNoteList: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
      (error) => {
          this.helperService.SaveException('DepositeActions.GetDepositeInventoryNote', error);

          this.bannerService.error(errorMessage);
        });
  }

  @Action(DepositeActions.GetDepositeInventoryStatuses)
  GetDepositeInventoryStatuses(
    context: StateContext<DepositeStateModel>,
  ) {

    let errorMessage = 'Błąd pobierania statusów inwentaryzacji.';

    let storageKey = DictionaryKeys.DepositeInventoryStatusesList;

    context.setState(
      patch({
        DepositeInventoryStatusesList: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.DepositeInventoryStatusesList) {
      this.depositeService.getDepositeInventoryStatuses().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              DepositeInventoryStatusesList: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('DepositeActions.GetDepositeInventoryStatuses', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(DepositeActions.GetDepositeList)
  GetDepositeList(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.GetDepositeList
  ) {

    let errorMessage = 'Błąd pobierania listy depozytów';

    context.setState(
      patch({
        DepositeList: null
      })
    );

    this.depositeService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            DepositeList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('DepositeActions.GetDepositeList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(DepositeActions.GetDepositePreviewList)
  GetDepositePreviewList(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.GetDepositePreviewList
  ) {

    let errorMessage = 'Błąd pobierania listy depozytów';

    this.depositeService.getPreviewList(action.Search).subscribe((ret) => {

      context.setState(
        patch({
          DepositePreviewList: ret
        })
      );

      if (ret.Success === false) {
        this.bannerService.error(ret.Message, errorMessage);
      }

      return ret;
    },
      (error) => {
        this.helperService.SaveException('DepositeActions.GetDepositePreviewList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(DepositeActions.SetDeposite)
  SetDeposite(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetDeposite
  ) {

    let errorMessage = 'Błąd zapisu depozytu';

    this.depositeService.set(action.Deposite).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zmainy depozytu zapisane.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Deposite: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DepositeActions.SetDeposite', error);

        this.bannerService.error(errorMessage);
      },
        () => { });
  }

  @Action(DepositeActions.SetInventory)
  SetInventory(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetDeposite
  ) {

    let errorMessage = 'Błąd zapisu inwentaryzacji depozytu';

    this.depositeService.setInventory(action.Deposite).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Inwentaryzacja depozytu zapisana.');
        }
        else {
          this.bannerService.error(ret.Message);
        }

        context.setState(
          patch({
            Deposite: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('DepositeActions.SetInventory', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DepositeActions.SetDepositeList)
  SetDepositeList(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetDepositeList
  ) {

    let errorMessage = 'Błąd zapisu zestawu depozytów';

    action.Deposites.IsProcessing = true;

    this.depositeService.setList(action.Deposites).subscribe(
      ret => {

        context.setState(
          patch({
            DepositePreviewList: ret
          })
        );

        if (ret.Success) {

          this.bannerService.success('Zmainy w zestawie depozytów zapisane');

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        return ret;
      },

      (error) => {

        this.helperService.SaveException('DepositeActions.SetDeposite', error);

        this.bannerService.error(errorMessage);

        patch({
          DepositeList: null
        })
      },
      () => {
        action.Deposites.IsProcessing = false;
      });
  }

  @Action(DepositeActions.SetDepositeSearch)
  SetDepositeSearch(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetDepositeSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        DepositeSearch: action.Search
      }));

    context.dispatch(new DepositeActions.GetDepositeList(action.Search));
  }

  @Action(DepositeActions.SetDepositeListPage)
  SetDepositeListPage(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetDepositeSearch
  ) {

    context.setState(
      patch({
        DepositeSearch: action.Search
      }));

    context.dispatch(new DepositeActions.GetDepositeList(action.Search));
  }

  @Action(DepositeActions.ResetDepositeSearch)
  ResetDepositeSearch(
    context: StateContext<DepositeStateModel>
  ) {

    const state = context.getState();

    const search = new DepositeSearchModel();

    search.ItemsPerPage = state.DepositeSearch.ItemsPerPage;

    context.setState(
      patch({
        DepositeSearch: search
      }));

    context.dispatch(new DepositeActions.GetDepositeList(search));
  }

  @Action(DepositeActions.GetDepositePdf)
  GetDepositePdf(
      context: StateContext<DepositeStateModel>,
      action: DepositeActions.GetDepositePdf
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie pliku pdf, proszę czekać.');

    this.depositeService.getPdf(action.Search).subscribe(ret => {
      const file = new File([ret], `Depozyty-${this.helperService.TimeStamp()}.pdf`, { type: 'application/pdf' });
      saveAs(file);
      },
        (error) => {

          this.helperService.SaveException('DepositeActions.GetDepositePdf', error);

          this.bannerService.error('Błąd pobierania pliku pdf.');
        },
      () => {
        context.setState(
          patch({
            ProcessingPdf: Math.random()
          })
        );

        }
      );
  }

  @Action(DepositeActions.ImportAgregatedExtended)
  ImportAgregatedExtended(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.ImportAgregatedExtended
  ) {

    this.bannerService.quickInfo('Rozpoczęto import listy ze zleceniami utylizacji i wydania opon, proszę czekać.');

    context.dispatch(new DepositeActions.SetImportAgregatedExtendedStatus(true));

    this.depositeService.importAgregatedExtended(action.Data).subscribe(ret => {

      this.helperService.consoleLog(ret.headers);

      const processed = ret.headers.get('x-import-processed');
      const error = ret.headers.get('x-import-error');
      const result = ret.headers.get('x-import-result');
      const message = ret.headers.get('x-import-message');
      const imported = Number(ret.headers.get('x-import-imported'));

      if (result === 'OK') {
        const file = new File([ret.body], `Wynik-Importu-${this.helperService.TimeStamp()}-${action.FileName}`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if (imported > 0) {
          this.bannerService.instantSuccess(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Zaimportowano ${imported}</b> pozycji.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }
        else {
          this.bannerService.instantMessage(`Zakończono import pliku <b>${action.FileName}</b><br/><b>Nie zaimporotwano żadnych pozycji</b>.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        } 

        saveAs(file);
      } else {

        if (message === 'IMPORT_EXCEPTION_EMPTY_FILE') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu jest pusty.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_FILE_EXTENSION') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwe rozszerzenie.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_HEDER') {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Plik przeznaczony do importu ma niewłaściwy nagłówek.`);
        } else {
          this.bannerService.instantError(`Zakończono import pliku <b>${action.FileName}</b><br/>Wystąpił nieznany błąd podczas przetwarzania pliku.`);
        }
      }
    },
      (error) => {

        this.helperService.SaveException('TyreOrderActions.Import', error);

        this.bannerService.error('Błąd importu zleceń zamówień opon.');

        context.dispatch(new DepositeActions.SetImportAgregatedExtendedStatus(false));
      },
      () => {
        context.dispatch(new DepositeActions.SetImportAgregatedExtendedStatus(false));
      }
    );
  }

  // this action state is responsible for clear the upload form
  @Action(DepositeActions.SetImportAgregatedExtendedStatus)
  SetImportStatus(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetImportAgregatedExtendedStatus
  ) {
    context.setState(
      patch({
        ImportAgregatedExtendedStatus: action.Status
      })
    );
  }

  @Action(DepositeActions.Get)
  Get(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.Get
  ) {
    const errorMessage = 'Błąd odczytu szczegółów depozytu.';

    this.depositeService.get(action.Id).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Deposite: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('DepositeActions.Get', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DepositeActions.ResetInventory)
  ResetInventory(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.ResetInventory
  ) {
    const errorMessage = 'Błąd resetowania inwentaryzacji depozytu.';

    this.depositeService.resetInventory(action.Deposite).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Deposite: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('DepositeActions.ResetInventory', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(DepositeActions.SetInventoryList)
  SetInventoryList(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.GetDepositeList
  ) {

    let errorMessage = 'Błąd potwierdzenia stanu listy depozytów';

    context.setState(
      patch({
        DepositeList: null
      })
    );

    this.depositeService.setInventoryList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            DepositeList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('DepositeActions.SetInventoryList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(DepositeActions.DisposeSearch)
  DisposeSearch(
    context: StateContext<DepositeStateModel>
  ) {

    context.setState(
      patch({
        DepositeSearch: null
      }));
  }

  @Action(DepositeActions.SetMarkList)
  SetMarkList(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetMarkList
  ) {
    context.getState();

    const errorMessage = 'Zaimportowany plik nie zawierał poprawnych danych.';

    context.setState(
      patch({
        MarkedRegistrationNumbers: null
      })
    );

    if (action.RegistrationNumbers) {
      if (action.RegistrationNumbers.length > 0) {
        context.setState(
          patch({
            MarkedRegistrationNumbers: action.RegistrationNumbers
          })
        );

      } else {
        this.bannerService.error(errorMessage);
      }
    }
  }

  @Action(DepositeActions.SetPickupCalls)
  SetPickupCalls(
    context: StateContext<DepositeStateModel>,
    action: DepositeActions.SetPickupCalls
  ) {

    let errorMessage = 'Błąd zapisu terminu odbioru przesyłki.';

    action.Request.IsProcessing = true;

    this.depositeService.setPickupCalls(action.Request).subscribe(
      ret => {

        context.setState(
          patch({
            DepositePreviewList: ret
          })
        );

        if (ret.Success) {

          this.bannerService.success(ret.Message);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }

        return ret;
      },

      (error) => {

        this.helperService.SaveException('DepositeActions.SetPickupCalls', error);

        this.bannerService.error(errorMessage);

        patch({
          DepositePreviewList: null
        })
      },
      () => {
        action.Request.IsProcessing = false;
      });
  }
}

